module.exports = __webpack_public_path__ + "assets/img/thumb-ISS-Super-NRL-Partnership-Video.2d0dd0c3.jpg";